import { render, staticRenderFns } from "./SettingsClient.vue?vue&type=template&id=0b06733c"
import script from "./SettingsClient.vue?vue&type=script&lang=js"
export * from "./SettingsClient.vue?vue&type=script&lang=js"
import style0 from "./SettingsClient.vue?vue&type=style&index=0&id=0b06733c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports